export default "__VITE_ASSET__3cptDJ29__"